module.exports = __webpack_public_path__ + "static/img/c5.dc3f1166.svg";